import React from 'react'
import { AnimatePresence, motion } from "framer-motion";
import { useGame } from '@/app/providers/GameContextProvider';
import { BiSolidShow } from "react-icons/bi";
import { FaBiohazard } from "react-icons/fa";
import { AUDIO, useAudio } from '@/app/providers/AudioProvider';

const OverlayButtons = ({
    hideHazards,
    setHideHazards,
    showResultOverlay,
    setShowResultOverlay,
} : {
    hideHazards: boolean;
    setHideHazards: React.Dispatch<React.SetStateAction<boolean>>;
    showResultOverlay: boolean;
    setShowResultOverlay: React.Dispatch<React.SetStateAction<boolean>>;
}) => {
    const { gameState } = useGame();
    const { play } = useAudio();

    if (!gameState) return null;

    return (
        <AnimatePresence>
            {!showResultOverlay && (
                <motion.div
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    exit={{ opacity: 0 }}
                    className="absolute top-1/2 right-5 md:right-20 z-50 -translate-y-1/2 flex gap-8"
                >
                    {/* Toggle Hazards Button - only show in Hazard mode when results are hidden */}
                    {gameState.hasHazardsActive && (
                        <div
                            onMouseEnter={() => {play(AUDIO.HOVER)}}
                            onClick={() => {play(AUDIO.CLICK); setHideHazards(!hideHazards)}}
                            className={`h-[60px] w-[60px] md:h-[80px] md:w-[80px] cursor-pointer rounded-[100%] flex items-center justify-center shadow-[0_0_5px_3px_rgba(0,0,0,0.5),inset_0_0_5px_3px_rgba(0,0,0,0.5)] hover:bg-[#6F6F6F] bg-[#575757] ${!hideHazards ? 'border-2 border-x-[#c0a270] border-y-[#e0c290]' : 'grayscale'} z-[10000]`}
                        >
                            {hideHazards ? (
                                <FaBiohazard className="text-4xl md:text-5xl text-[#c0a270]" />
                            ) : (
                                <FaBiohazard className="text-4xl md:text-5xl text-[#c0a270]" />
                            )}
                        </div>
                    )}
                    <motion.div
                        animate={{ scaleX: [1, 1, 1.2, 1], scaleY: [1, 1, 1.1, 1] }}
                        transition={{
                            scaleX: { repeat: Infinity, duration: 1.5, times: [0, 0.6, 0.65, 1] },
                            scaleY: { repeat: Infinity, duration: 1.5, times: [0, 0.6, 0.65, 1] },
                        }}
                    >
                        {/* Show Results Button */}
                        <div
                            onClick={() => {play(AUDIO.CLICK); setShowResultOverlay(true)}}
                            onMouseEnter={() => {play(AUDIO.HOVER)}}
                            className="h-[60px] w-[60px] md:h-[80px] md:w-[80px] cursor-pointer rounded-[100%] flex items-center justify-center shadow-[0_0_5px_3px_rgba(0,0,0,0.5),inset_0_0_5px_3px_rgba(0,0,0,0.5)] hover:bg-[#6F6F6F] bg-[#575757] border-2 border-x-[#c0a270] border-y-[#e0c290] z-[10000]"
                        >
                            <BiSolidShow className="text-4xl md:text-6xl text-[#c0a270]" />
                        </div>
                    </motion.div>
                </motion.div>
            )}
            </AnimatePresence>
    )
}

export default OverlayButtons